import { useCuratedEventsStore } from '~/stores/apostatudo/curated-events';
import { fetchCuratedEventsHandler } from '~/handlers/fetch-curated-events.handler';

const DEFAULT_LIMIT = 50;

function todayIsoDate(): string {
  const now = new Date();
  const yyyy = now.getFullYear();
  const mm = String(now.getMonth() + 1).padStart(2, '0');
  const dd = String(now.getDate()).padStart(2, '0');

  return `${yyyy}-${mm}-${dd}`;
}

export const useCuratedEvents = () => {
  const store = useCuratedEventsStore();

  const fetchAll = async () => {
    if (store.fetched) return;

    store.loading = true;
    store.error = null;

    try {
      const { events } = await fetchCuratedEventsHandler({
        limit: DEFAULT_LIMIT,
      });

      if (!events) {
        throw new Error('API returned null curated events');
      }

      store.setEvents(events);

      const uniqueDates = new Set<string>();

      for (const e of store.events) {
        if (e.eventDate) uniqueDates.add(e.eventDate);
      }

      const dates = [...uniqueDates].sort();

      store.setAvailableDates(dates);

      if (!store.selectedDate && dates.length > 0) {
        const today = todayIsoDate();
        const initial = dates.includes(today) ? today : dates[0]!;

        store.setSelectedDate(initial);
      }
    } catch (err) {
      console.error(
        '[useCuratedEvents] ❌ Erro ao buscar curated events:',
        err,
      );
      store.error = err instanceof Error ? err.message : 'Unknown error';
    } finally {
      store.loading = false;
    }
  };

  return {
    fetchAll,
    setSelectedDate: store.setSelectedDate,
    events: computed(() => store.events),
    selectedDate: computed(() => store.selectedDate),
    availableDates: computed(() => store.availableDates),
    hasEvents: computed(() => store.hasEvents),
    loading: computed(() => store.loading),
    error: computed(() => store.error),
  };
};
